
import axios from "axios";
import { store } from "store";
import { OutputBaseProps } from "utils/types/API";
import { WorkflowItemProps } from ".";
import { loading, create } from "store/workflow";
import { AppMessage } from "components";

interface ApiWorkflowCreateInputProps extends Omit<WorkflowItemProps, "id"> {
}

type ApiWorkflowCreateOutputProps = OutputBaseProps<{ item: WorkflowItemProps; }, ApiWorkflowCreateInputProps>

export const apiWorkflowCreate = async (data: ApiWorkflowCreateInputProps) => {
    store.dispatch(loading());
    const res = (await axios.post<ApiWorkflowCreateOutputProps>("/api/workflow/create", data))
        .data;
    if (res.code === 0 && res.data) {
        store.dispatch(create({ data: res.data.item }));
        AppMessage.success({
            title: "Thông báo",
            message: res.message
        })
    }
    return res;
};